//url for production
import * as XLSX from "xlsx";
import { ToWords } from "to-words";
export var url = "";
if (process.env.NODE_ENV === "development") {
  url = "";
} else {
  url = window.location.host.split("/")[1];
  if (url) {
    url = `/${window.location.host.split("/")[1]}`;
  } else url = process.env.PUBLIC_URL; /// ADD YOUR CPANEL SUB-URL
}

// Logs out user
export const handleSignout = () => {
  localStorage.removeItem("access-token");
};

//Function to validate and return errors for a form
export const checkForm = (formData) => {
  let errorState = {};
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "") {
      errorState[item] = "This field is required";
    }
  });
  return errorState;
};

//Function that returns the first or first two letters from a name
export const findUpper = (string) => {
  let extractedString = [];

  for (var i = 0; i < string.length; i++) {
    if (
      string.charAt(i) === string.charAt(i).toUpperCase() &&
      string.charAt(i) !== " "
    ) {
      extractedString.push(string.charAt(i));
    }
  }
  if (extractedString.length > 1) {
    return extractedString[0] + extractedString[1];
  } else {
    return extractedString[0];
  }
};

//Function that calculates the from current date
export const setDeadline = (days) => {
  let todayDate = new Date();
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// Function to structure date ex : Jun 4, 2011;
export const getDateStructured = (date) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  let final = monthNames[m] + " " + d + ", " + y;
  return final;
};

// Function to structure date ex: YYYY-MM-DD
export const setDateForPicker = (rdate) => {
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = y + "-" + m + "-" + d;

  return rdate;
};

// Set deadlines for projects
export const setDeadlineDays = (deadline) => {
  var currentDate = new Date();
  var difference = deadline.getTime() - currentDate.getTime();
  var days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

//Date formatter function
export const dateFormatterAlt = (date, reverse) => {
  let d = date.getDate();
  let m = date.getMonth() + 1;
  let y = date.getFullYear();
  reverse
    ? (date = m + " - " + d + " - " + y)
    : (date = y + " - " + d + " - " + m);
  return date;
};

//Date formatter function
export const dateFormatter = (date, reverse, string) => {
  var dateformat = date.split("-");
  //var date = dateformat[1]+"-"+dateformat[2]+"-"+dateformat[0];
  reverse
    ? (date = dateformat[2] + "-" + dateformat[0] + "-" + dateformat[1])
    : (date = dateformat[1] + "-" + dateformat[2] + "-" + dateformat[0]);

  return date;
};

//todays Date
export const todaysDate = new Date();

//current Time
export const currentTime = () => {
  var hours = todaysDate.getHours();
  var minutes = todaysDate.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

//Percentage calculation
export const calcPercentage = (str1, str2) => {
  let result = Number(str2) / Number(str1);
  result = result * 100;
  return Math.floor(result);
};

export const truncate = (str, n) => {
  return str.length > n
    ? str.substr(0, n - 1) + " " + truncate(str.substr(n - 1, str.length), n)
    : str;
};

// returns upload url
export const getUploadParams = () => {
  return { url: "https://httpbin.org/post" };
};

export const bulkActionOptions = [
  { value: "suspend", label: "Suspend User" },
  { value: "delete", label: "Delete User" },
];

// Converts KB to MB
export const bytesToMegaBytes = (bytes) => {
  let result = bytes / (1024 * 1024);
  return result.toFixed(2);
};

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const addDays = (date, days) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

// Returns Currency based value for invest panel
export const returnCurrency = (currency, data, upperCase) => {
  if (currency === "usd") {
    return { value: data.usd.toFixed(2), label: upperCase ? "USD" : "$" };
  } else if (currency === "eur") {
    return { value: data.euro.toFixed(2), label: upperCase ? "EUR" : "euro" };
  } else if (currency === "btc") {
    return { value: data.BTC.toFixed(6), label: "BTC" };
  } else {
    return { value: data.ETH.toFixed(2), label: "ETH" };
  }
};

// Returns levels
export const returnLevel = (currency, data, upperCase) => {
  if (currency === "usd") {
    return data.usd;
  } else if (currency === "eur") {
    return data.euro;
  } else if (currency === "btc") {
    let amount = data.BTC.map((item) => {
      return item.toFixed(6);
    });
    return amount;
  } else {
    return data.ETH;
  }
};

//Currency Format e.g pass INR as currency will return ruppee icon 1,000
export const formatCurrency = (value, currency) => {
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
    }).format(value);
  } catch (error) {
    console.log(error);
    return "--";
  }
};
export const formatDecimal = (value) => {
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch (error) {
    console.log(error);
    return "--";
  }
};

// User labels
export const getUserLabel = (name) => {
  const cleanedName = name.trim().replace(/\s+/g, " ");
  const words = cleanedName?.split(" ");
  if (words?.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }
  console.log("words[0][0]", words[0][0]);
  return (words[0][0] + words[1][0]).toUpperCase();
};

export const colors = [
  "#173F5F",
  "#20639B",
  "#3CAEA3",
  "#F6D55C",
  "#ED553B",
  "#e81e63",
  "#03a9f4",
  "#cddc39",
  "#9c27b0",
  "#ffeb3b",
];

export const formatCurrency2 = (value, currency) => {
  try {
    const formatter = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    let formattedValue;

    if (currency === "INR") {
      if (value >= 10000000000) {
        // 10,000,000,000 or 1,000 Crores
        formattedValue = `${formatter.format(value / 10000000000)} K Cr`; // K Cr for Thousand Crores
      } else if (value >= 10000000) {
        // 10,000,000 or 1 Crore
        formattedValue = `${formatter.format(value / 10000000)} Cr`;
      } else if (value >= 100000) {
        // 100,000 or 1 Lakh
        formattedValue = `${formatter.format(value / 100000)} L`;
      } else {
        formattedValue = formatter.format(value);
      }
    } else if (
      currency === "USD" ||
      currency === "EUR" ||
      currency === "GBP" ||
      currency === "AED"
    ) {
      if (value >= 1000000000000) {
        // 1,000,000,000,000 or 1 Trillion
        formattedValue = `${formatter.format(value / 1000000000000)} Tn`;
      } else if (value >= 1000000000) {
        // 1,000,000,000 or 1 Billion
        formattedValue = `${formatter.format(value / 1000000000)} Bn`;
      } else if (value >= 1000000) {
        // 1,000,000 or 1 Million
        formattedValue = `${formatter.format(value / 1000000)} M`;
      } else {
        formattedValue = formatter.format(value);
      }

      // Manually add AED symbol if currency is AED
      if (currency === "AED") {
        formattedValue = `د.إ ${formattedValue.slice(3)}`;
      }
    } else {
      // Fallback for other currencies like MYR, SGD, KWD
      if (value >= 1000000000000) {
        // 1,000,000,000,000 or 1 Trillion
        formattedValue = `${formatter.format(value / 1000000000000)} Tn`;
      } else if (value >= 1000000000) {
        // 1,000,000,000 or 1 Billion
        formattedValue = `${formatter.format(value / 1000000000)} Bn`;
      } else if (value >= 1000000) {
        // 1,000,000 or 1 Million
        formattedValue = `${formatter.format(value / 1000000)} M`;
      } else {
        formattedValue = formatter.format(value);
      }

      // Manually handle specific currencies
      switch (currency) {
        case "MYR": // Malaysian Ringgit
          formattedValue = `RM ${formattedValue.slice(3)}`;
          break;
        case "SGD": // Singapore Dollar
          formattedValue = `S$ ${formattedValue.slice(3)}`;
          break;
        case "KWD": // Kuwaiti Dinar
          formattedValue = `KD ${formattedValue.slice(3)}`;
          break;
        default:
          // Fallback if no specific symbol manipulation is needed
          formattedValue = formatter.format(value);
      }
    }

    return formattedValue;
  } catch (error) {
    console.log(error);
    return "--";
  }
};

export const convertNumberToWords = (amount) => {
  try {
    const _toWords = new ToWords({
      localeCode: "en-IN", // For Indian numbering system
      converterOptions: {
        currency: true, // Enables currency formatting
        ignoreDecimal: false, // Includes decimal values
        ignoreZeroCurrency: false, // Includes "Zero Rupees" for 0
        doNotAddOnly: false, // Adds "Only" at the end
      },
    });

    return _toWords.convert(amount);
  } catch (error) {}
};

// status
export const normalizeStatus = (status) => {
  if (!status) return "N/A";

  const s = status.trim().toLowerCase();
  if (["active", "activate"].includes(s)) return "Active";
  if (["inactive", "inactivate"].includes(s)) return "Inactive";
  if (["onhold", "on hold", "hold"].includes(s)) return "OnHold";
  return status;
};

//expoert to xlsx
export const exportToXLSX = (data, fileName) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

// ============================================================
// PR Site Structure Transformation Utilities
// ============================================================

/**
 * Groups UI material rows by materialId and aggregates site allocations into siteStructures array
 * Used when transforming form data (items[]) to API payload (prLines with siteStructures[])
 *
 * @param {Array} items - Array of material items from UI (each row is a separate item)
 * @returns {Array} - Grouped materials with siteStructures array
 *
 * Example Input:
 * [
 *   { materialName: "123", quantity: 10, towerBlockVillaId: "1", floorNo: "1" },
 *   { materialName: "123", quantity: 15, towerBlockVillaId: "1", floorNo: "2" },
 *   { materialName: "456", quantity: 20, towerBlockVillaId: "2" }
 * ]
 *
 * Example Output:
 * [
 *   {
 *     materialName: "123",
 *     materialCategory: "...",
 *     totalQuantity: 25,
 *     siteStructures: [
 *       { unitId: "1", floorNo: "1", quantity: 10, ... },
 *       { unitId: "1", floorNo: "2", quantity: 15, ... }
 *     ]
 *   },
 *   {
 *     materialName: "456",
 *     totalQuantity: 20,
 *     siteStructures: [{ unitId: "2", quantity: 20, ... }]
 *   }
 * ]
 */
export const groupMaterialsBySiteStructure = (items) => {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return [];
  }

  // Group items by materialId (materialName in form data)
  const grouped = {};

  items.forEach((item) => {
    const materialKey = item.materialName?.toString();

    if (!materialKey) {
      console.warn("Item missing materialName, skipping:", item);
      return;
    }

    // Initialize group if not exists
    if (!grouped[materialKey]) {
      grouped[materialKey] = {
        // Preserve IDs explicitly for API submission
        materialId: item.materialId,
        categoryId: item.categoryId,

        // Keep existing fields for compatibility
        materialName: item.materialName,
        materialLabel: item.materialLabel,
        materialCategory: item.materialCategory || item.categoryId,
        categoryLabel: item.categoryLabel,
        uomId: item.uomId,
        uomLabel: item.uomLabel,
        specification: item.specification,
        remarks: item.remarks,
        makeInfo: [], // Initialize empty, will merge from all rows
        prLineId: item.prLineId, // Preserve for updates
        totalQuantity: 0,
        siteStructures: [],
      };
    }

    // Merge makeInfo from current item (deduplicate by makeId)
    if (item.makeInfo && Array.isArray(item.makeInfo) && item.makeInfo.length > 0) {
      const existingMakeIds = new Set(
        grouped[materialKey].makeInfo.map((m) => m.makeId)
      );
      item.makeInfo.forEach((make) => {
        if (!existingMakeIds.has(make.makeId)) {
          grouped[materialKey].makeInfo.push(make);
        }
      });
    }

    // Add site structure allocation
    const siteStructure = {
      prLineSiteStructureId: item.prLineSiteStructureId || null, // Critical for updates
      unitId: item.towerBlockVillaId || item.siteStructureUnitId || null,
      unitLabel: item.towerBlockVillaLabel || item.unitName || null,
      floorNo: item.floorNo || null,
      subUnitId: item.flatId || item.siteStructureSubUnitId || null,
      subUnitLabel: item.flatLabel || item.subUnitName || null,
      locationId: item.locationId || null,
      locationLabel: item.locationLabel || item.locationName || null,
      quantity: parseFloat(item.quantity) || 0,
    };

    grouped[materialKey].siteStructures.push(siteStructure);
    grouped[materialKey].totalQuantity += siteStructure.quantity;
  });

  return Object.values(grouped);
};

/**
 * Flattens API response with siteStructures[] back to UI row format
 * Used when loading PR data for view/edit - converts grouped structure to individual rows
 * Also handles backward compatibility with old PRs that don't have siteStructures
 *
 * @param {Array} prLines - Array of PR lines from API
 * @returns {Array} - Flattened rows for UI display
 *
 * Example Input (New Format):
 * [
 *   {
 *     materialId: 123,
 *     quantity: 25,
 *     siteStructures: [
 *       { prLineSiteStructureId: 1, siteStructureUnitId: 10, floorNo: "1", quantity: 10 },
 *       { prLineSiteStructureId: 2, siteStructureUnitId: 10, floorNo: "2", quantity: 15 }
 *     ]
 *   }
 * ]
 *
 * Example Output:
 * [
 *   { materialId: 123, towerBlockVillaId: 10, floorNo: "1", quantity: 10, prLineSiteStructureId: 1, ... },
 *   { materialId: 123, towerBlockVillaId: 10, floorNo: "2", quantity: 15, prLineSiteStructureId: 2, ... }
 * ]
 */
export const flattenSiteStructuresToRows = (prLines) => {
  if (!prLines || !Array.isArray(prLines)) {
    return [];
  }

  return prLines.flatMap((line) => {
    // NEW API format (with siteStructures array)
    if (line.siteStructures && Array.isArray(line.siteStructures) && line.siteStructures.length > 0) {
      return line.siteStructures.map((site) => ({
        // Site structure specific fields
        prLineSiteStructureId: site.prLineSiteStructureId || null,
        siteStructureUnitId: site.siteStructureUnitId || null,
        towerBlockVillaId: site.siteStructureUnitId || null, // Alias for UI compatibility

        // Fix: API sends "siteStructureUnitName" not "unitName"
        unitName: site.siteStructureUnitName || null,
        towerBlockVillaLabel: site.siteStructureUnitName || null,
        towerBlockVillaName: site.siteStructureUnitName || null, // ViewPRDetails expects this
        siteStructureUnitName: site.siteStructureUnitName || null, // Keep original API field

        floorNo: site.floorNo || null,
        siteStructureSubUnitId: site.siteStructureSubUnitId || null,
        flatId: site.siteStructureSubUnitId || null, // Alias for UI compatibility

        // Fix: API sends "siteStructureSubUnitName" not "subUnitName"
        subUnitName: site.siteStructureSubUnitName || null,
        flatLabel: site.siteStructureSubUnitName || null,
        siteStructureSubUnitName: site.siteStructureSubUnitName || null, // Keep original API field

        locationId: site.locationId || null,
        locationName: site.locationName || null,
        locationLabel: site.locationName || null,
        quantity: site.quantity || 0,

        // Material-level fields (shared across all rows of same material)
        prLineId: line.prLineId || line.id,
        materialId: line.materialId,
        materialName: line.materialName, // Fix: Use actual name, not ID
        materialLabel: line.materialName,
        categoryId: line.categoryId,
        materialCategory: line.categoryId, // Alias for form compatibility
        categoryLabel: line.categoryName,
        categoryName: line.categoryName, // Add for consistency
        uomId: line.uomId,
        uomLabel: line.uomName || line.uom,
        uomName: line.uomName || line.uom, // Add for consistency
        specification: line.specification || "",
        remarks: line.remarks || "",
        makeInfo: line.makeInfo || [],
        headerStaus: line.headerStaus, // Preserve if exists
      }));
    }

    // OLD API format (flat structure without siteStructures) - backward compatibility
    return [{
      prLineId: line.prLineId || line.id,
      materialId: line.materialId,
      materialName: line.materialName, // Fix: Use actual name, not ID
      materialLabel: line.materialName,
      categoryId: line.categoryId,
      materialCategory: line.categoryId,
      categoryLabel: line.categoryName,
      categoryName: line.categoryName, // Add for consistency
      quantity: line.quantity || 0,
      uomId: line.uomId,
      uomLabel: line.uomName || line.uom,
      uomName: line.uomName || line.uom, // Add for consistency
      specification: line.specification || "",
      remarks: line.remarks || "",
      makeInfo: line.makeInfo || [],

      // Old site fields (if they exist at line level) - with fallbacks
      siteStructureUnitId: line.siteStructureUnitId || null,
      towerBlockVillaId: line.siteStructureUnitId || null,
      unitName: line.unitName || line.siteStructureUnitName || null,
      towerBlockVillaLabel: line.unitName || line.siteStructureUnitName || null,
      towerBlockVillaName: line.unitName || line.siteStructureUnitName || null, // Add for ViewPRDetails
      siteStructureUnitName: line.siteStructureUnitName || line.unitName || null, // Keep original

      floorNo: line.floorNo || null,
      siteStructureSubUnitId: line.siteStructureSubUnitId || null,
      flatId: line.siteStructureSubUnitId || null,
      subUnitName: line.subUnitName || line.siteStructureSubUnitName || null,
      flatLabel: line.subUnitName || line.siteStructureSubUnitName || null,
      siteStructureSubUnitName: line.siteStructureSubUnitName || line.subUnitName || null, // Keep original

      locationId: line.locationId || null,
      locationName: line.locationName || null,
      locationLabel: line.locationName || null,
      headerStaus: line.headerStaus,
    }];
  });
};

/**
 * Validates grouped materials with siteStructures
 * Ensures quantity sums match and basic hierarchy rules are met
 *
 * @param {Array} groupedMaterials - Output from groupMaterialsBySiteStructure
 * @returns {Object} - { isValid: boolean, errors: string[] }
 */
export const validateSiteStructureGrouping = (groupedMaterials) => {
  const errors = [];

  if (!groupedMaterials || !Array.isArray(groupedMaterials)) {
    return { isValid: true, errors: [] };
  }

  groupedMaterials.forEach((material, index) => {
    const materialLabel = material.materialLabel || material.materialName || `Material ${index + 1}`;

    // Rule 1: At least one site structure per material
    if (!material.siteStructures || material.siteStructures.length === 0) {
      errors.push(`${materialLabel}: At least one site allocation is required`);
      return;
    }

    // Rule 2: Sum of siteStructure quantities should match total
    const siteSum = material.siteStructures.reduce((sum, site) => sum + (parseFloat(site.quantity) || 0), 0);
    const totalQty = parseFloat(material.totalQuantity) || 0;

    // Allow small floating point differences (0.01)
    if (Math.abs(siteSum - totalQty) > 0.01) {
      errors.push(
        `${materialLabel}: Site allocation quantities (${siteSum.toFixed(2)}) don't match total quantity (${totalQty.toFixed(2)})`
      );
    }

    // Rule 3: Each site structure should have quantity > 0
    material.siteStructures.forEach((site, siteIndex) => {
      const qty = parseFloat(site.quantity) || 0;
      if (qty <= 0) {
        errors.push(`${materialLabel}: Site allocation ${siteIndex + 1} has invalid quantity (${qty})`);
      }
    });
  });

  return {
    isValid: errors.length === 0,
    errors: errors,
  };
};